const LoadingScreen = () => {
  return (
    <div className='fixed text-gray-800 flex justify-center items-center text-5xl w-screen h-screen bg-gray-800 bg-opacity-30'>
      Loading...
    </div>
  )
}

export default LoadingScreen
